exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".plainWhiteLogoHeader{background-color:#fff}.plainWhiteLogoHeader .headerSection{text-align:center;padding:20px 0;border-bottom:1px solid #ddd}", ""]);

// exports
